import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend } from "recharts";

function LineGraph({ data, xLabelKey, yLabelKey, yAxisProps, legends = [], width, height, className = "", animation = true }) {
	return (
		<LineChart className={className} width={width} height={height} data={data}>
			<XAxis dataKey={xLabelKey} />
			<YAxis dataKey={yLabelKey} />
			<YAxis {...yAxisProps} />
			<Tooltip />
			<Legend />
			{legends.map((line, i) => {
				return <Line key={i} type="monotone" dataKey={line.title} stroke={line.color} activeDot={{ r: 8 }} strokeWidth={2} />;
			})}
		</LineChart>
	);
}

export default LineGraph;
